import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "grow md:flex-row justify-center pb-4 md:pb-0 md:flex md:justify-center" }, null, -1)

import { ref } from "vue";
import NavBar from "./NavBar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBarPublic',
  setup(__props) {

const open = ref(false);
const onToggleNavigation = () => {
  open.value = !open.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NavBar, {
    open: open.value,
    onToggleNavigation: onToggleNavigation
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})